import { __extends } from "tslib";
import { Emitter } from '../../core/emitter';
import { backoff } from './backoff';
/**
 * @internal
 */
export var ON_REMOVE_FROM_FUTURE = 'onRemoveFromFuture';
var PriorityQueue = /** @class */ (function (_super) {
    __extends(PriorityQueue, _super);
    function PriorityQueue(maxAttempts, queue, seen) {
        var _this = _super.call(this) || this;
        _this.future = [];
        _this.maxAttempts = maxAttempts;
        _this.queue = queue;
        _this.seen = seen !== null && seen !== void 0 ? seen : {};
        return _this;
    }
    PriorityQueue.prototype.push = function () {
        var _this = this;
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        var accepted = operations.map(function (operation) {
            var attempts = _this.updateAttempts(operation);
            if (attempts > _this.maxAttempts || _this.includes(operation)) {
                return false;
            }
            _this.queue.push(operation);
            return true;
        });
        this.queue = this.queue.sort(function (a, b) { return _this.getAttempts(a) - _this.getAttempts(b); });
        return accepted;
    };
    PriorityQueue.prototype.pushWithBackoff = function (operation) {
        var _this = this;
        if (this.getAttempts(operation) === 0) {
            return this.push(operation)[0];
        }
        var attempt = this.updateAttempts(operation);
        if (attempt > this.maxAttempts || this.includes(operation)) {
            return false;
        }
        var timeout = backoff({ attempt: attempt - 1 });
        setTimeout(function () {
            _this.queue.push(operation);
            // remove from future list
            _this.future = _this.future.filter(function (f) { return f.id !== operation.id; });
            // Lets listeners know that a 'future' message is now available in the queue
            _this.emit(ON_REMOVE_FROM_FUTURE);
        }, timeout);
        this.future.push(operation);
        return true;
    };
    PriorityQueue.prototype.getAttempts = function (operation) {
        var _a;
        return (_a = this.seen[operation.id]) !== null && _a !== void 0 ? _a : 0;
    };
    PriorityQueue.prototype.updateAttempts = function (operation) {
        this.seen[operation.id] = this.getAttempts(operation) + 1;
        return this.getAttempts(operation);
    };
    PriorityQueue.prototype.includes = function (operation) {
        return (this.queue.includes(operation) ||
            this.future.includes(operation) ||
            Boolean(this.queue.find(function (i) { return i.id === operation.id; })) ||
            Boolean(this.future.find(function (i) { return i.id === operation.id; })));
    };
    PriorityQueue.prototype.pop = function () {
        return this.queue.shift();
    };
    Object.defineProperty(PriorityQueue.prototype, "length", {
        get: function () {
            return this.queue.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PriorityQueue.prototype, "todo", {
        get: function () {
            return this.queue.length + this.future.length;
        },
        enumerable: false,
        configurable: true
    });
    return PriorityQueue;
}(Emitter));
export { PriorityQueue };
//# sourceMappingURL=index.js.map